import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: Country does not have a nse pyramid
 */
export class PaisSinPiramideNseParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Country does not have a nse pyramid");
    }

    public traducir(): string {
        return "El pais seleccionado no tiene una piramide NSE cargada para ponderar";
    }
}
